export default "__VITE_ASSET__DRryw5xf__"